import * as React from 'react';

function CarretArrowUpSC(props) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.587 17.863a.587.587 0 01-.768-.012.453.453 0 01.013-.689l5.793-5.025a.588.588 0 01.755 0l5.788 5.025a.453.453 0 01.013.69.587.587 0 01-.768.011l-5.41-4.698-5.416 4.698z"
        fill="#414B56"
      />
    </svg>
  );
}

export default CarretArrowUpSC;
